import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import DXSelectFilter from '../DXSelectFilter/DXSelectFilter';
import DXFilterConfig from '../DXFilterConfig';
import constants from '../../constants';

const propTypes = {
  equality: PropTypes.string,
  selected: PropTypes.array,
  onChange: PropTypes.func.isRequired,
};

const defaultProps = {
  selected: [],
};

class DXCustomerTypeFilter extends React.Component {
  render() {
    const { selected, onChange, intl, equality } = this.props;
    const config = DXCustomerTypeFilter.getConfig(intl, equality);
    return (
      <DXSelectFilter
        selected={selected}
        title={config.title}
        values={config.values}
        onChange={onChange}
        multi={config.multi}
      />
    );
  }
}

DXCustomerTypeFilter.propTypes = propTypes;
DXCustomerTypeFilter.defaultProps = defaultProps;
DXCustomerTypeFilter.getLabel = (intl, selectedValues) => {
  return DXSelectFilter.getLabel(intl, 'filter.types.', selectedValues);
};
DXCustomerTypeFilter.applyToQueryParams = (queryParams, selectedValues, filter) => {
  const param =
    !!filter.queryParams && filter.queryParams.types && filter.queryParams.types.default
      ? filter.queryParams.types.default
      : 'types';

  queryParams[param] = selectedValues;
  return queryParams;
};
DXCustomerTypeFilter.getConfig = (intl, equality, queryParamsByFilterName) => {
  let config = new DXFilterConfig({
    name: 'types',
    selected: [],
    property: 'types',
    title: intl.formatMessage({ id: 'filter.type' }),
    disabled: false,
    equalityStatus: false,
    multi: true,
    queryParams: queryParamsByFilterName,
  });

  if (equality === constants.FILTER_EQUALITY_EQUALS) {
    config.addFilterValue('retail', intl.formatMessage({ id: 'filter.types.retail' }));
    config.addFilterValue('wholesale', intl.formatMessage({ id: 'filter.types.wholesale' }));
  }

  return config;
};

DXCustomerTypeFilter.getInitialConfig = (intl, values, readOnly, invisible) => {
  return {
    name: 'types',
    title: intl.formatMessage({ id: 'filter.type' }),
    property: 'types',
    type: 'types',
    selectedValues: values,
    clientSide: false,
    readOnly: readOnly ? readOnly : false,
    fromVariable: !!invisible || false,
  };
};

export default injectIntl(DXCustomerTypeFilter);
